var _path, _path2, _circle, _circle2, _circle3, _circle4, _circle5, _path3, _circle6, _circle7, _circle8, _circle9, _circle0, _ellipse, _path4, _line, _line2, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDis1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 153,
    viewBox: "0 0 153 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.6928 91.3499H71.4872M40.7598 67.1404L45 56",
    stroke: "#499456",
    strokeWidth: 2.48302
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7214 114.021H45.9025C49.6147 114.021 52.6239 111.012 52.6239 107.3V102.974C52.6239 101.597 52.21 100.246 51.2617 99.2468C49.1394 97.0113 44.6172 93.2448 38.2626 93.2776C31.9188 93.3102 27.4499 97.0374 25.352 99.2528C24.4098 100.248 24 101.593 24 102.963V107.3C24 111.012 27.0093 114.021 30.7214 114.021Z",
    fill: "#61B06F"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38.3113,
    cy: 83.8328,
    r: 11.4148,
    fill: "#61B06F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.75,
    cy: 82.3262,
    r: 2.9551,
    fill: "#F1F1F1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.75,
    cy: 82.3262,
    r: 2.9551,
    fill: "#F1F1F1"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.5274,
    cy: 82.3262,
    r: 2.9551,
    fill: "#F1F1F1"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.5274,
    cy: 82.3262,
    r: 2.9551,
    fill: "#F1F1F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M101.487 114.021H116.668C120.38 114.021 123.39 111.012 123.39 107.3V102.974C123.39 101.597 122.976 100.246 122.027 99.2468C119.905 97.0113 115.383 93.2448 109.028 93.2776C102.684 93.3102 98.2156 97.0374 96.1176 99.2528C95.1754 100.248 94.7656 101.593 94.7656 102.963V107.3C94.7656 111.012 97.7749 114.021 101.487 114.021Z",
    fill: "#61B06F"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 109.077,
    cy: 83.8328,
    r: 11.4148,
    fill: "#61B06F"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 103.516,
    cy: 82.3262,
    r: 2.9551,
    fill: "#F1F1F1"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 103.516,
    cy: 82.3262,
    r: 2.9551,
    fill: "#F1F1F1"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 114.293,
    cy: 82.3262,
    r: 2.9551,
    fill: "#F1F1F1"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 114.293,
    cy: 82.3262,
    r: 2.9551,
    fill: "#F1F1F1"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.7265,
    cy: 47.98,
    rx: 21.7265,
    ry: 11.98,
    fill: "#535467"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.582 66.2448C66.1461 62.9402 69.3173 52.843 69.8324 48.2074L65.3154 48.0619C68.162 52.4519 61.3459 62.013 57.582 66.2448Z",
    fill: "#535467"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 69.4261,
    y1: 51.3889,
    x2: 76.8757,
    y2: 43.9393,
    stroke: "#BB777B",
    strokeWidth: 2.12607
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 69.5134,
    y1: 43.9397,
    x2: 76.6003,
    y2: 51.0266,
    stroke: "#BB777B",
    strokeWidth: 2.12607
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5215 83.5916L67.764 79.5566",
    stroke: "#499456",
    strokeWidth: 2.48302
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDis1);
export default __webpack_public_path__ + "static/media/dis-1.376cf902aee5520799763c4d2245ac1f.svg";
export { ForwardRef as ReactComponent };